import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useApp } from "../context/AppContext";
import { isIOSApp, purchaseApplePlan } from "../utils/appleIAP";
const SessionExpiredModal = ({ onRenewed }) => {
  const { t, i18n } = useTranslation();
  const { updatePlan } = useApp();
  const [loading, setLoading] = useState(false);
  const isAr = i18n.language === "ar";
  const handleRenew = async () => {
    setLoading(true);
    try {
      if (isIOSApp()) {
        // iOS app: renew the hour through Apple IAP (App Review 3.1.1)
        const r = await purchaseApplePlan("hourly", 1);
        if (r?.plan) updatePlan(r.plan, r.remainingSeconds);
        onRenewed?.();
        return;
      }
      const o = await axios.post("/api/payment/buy-hour");
      const p = await axios.post("/api/payment/simulate-payment", { orderId: o.data.orderId, simulateSuccess: true });
      updatePlan(p.data.plan, p.data.remainingSeconds);
      onRenewed?.();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  return <div className="expired-overlay">
      <div className="expired-card" dir={isAr ? "rtl" : "ltr"}>
        <span className="expired-moon">🌙</span>
        <h2 className="expired-title">{t("sessionExpiredTitle")}</h2>
        <p className="expired-msg" style={{ whiteSpace: "pre-line" }}>
          {isAr ? t("sessionExpiredAr") : t("sessionExpiredEn")}
        </p>
        <button className="btn-renew" onClick={handleRenew} disabled={loading}>
          {loading ? <><div className="spinner" /> {isAr ? "\u062C\u0627\u0631\u064A \u0627\u0644\u062A\u0641\u0639\u064A\u0644..." : "Activating..."}</> : <>{isAr ? "\u2728" : "\u{1F31F}"} {t("buyNewHour")}</>}
        </button>
      </div>
    </div>;
};
var stdin_default = SessionExpiredModal;
export {
  stdin_default as default
};
